import { c as _c } from "react/compiler-runtime";
import { UseIsVisibleType } from "@website/hooks/is-visible/is-visible.types";
import { RefObject, useEffect, useRef, useState } from "react";
export const useIsVisible: UseIsVisibleType = (options, defaultValue) => {
  const $ = _c(5);
  const reference = useRef(null);
  const [inView, setInView] = useState(defaultValue || false);
  let t0;
  let t1;
  if ($[0] !== options) {
    t0 = () => {
      const observer = new IntersectionObserver(t2 => {
        const [entry] = t2;
        return setInView?.(entry.isIntersecting);
      }, options ?? {});
      const reference_ = reference.current;
      reference_ && observer?.observe(reference_);
      return () => {
        reference_ && observer?.unobserve(reference_);
      };
    };
    t1 = [options];
    $[0] = options;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== inView) {
    t2 = {
      reference: reference as RefObject<HTMLDivElement>,
      inView
    };
    $[3] = inView;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};